import { useTranslation } from 'react-i18next';
import { useGetRequiredRule } from '@/hooks';
import { RobotsFormFieldsNames } from '../helpers/types';

export const useRobotsFormRules = () => {
  const { t } = useTranslation(['validations']);

  const requiredRule = useGetRequiredRule({ t });

  return {
    [RobotsFormFieldsNames.CONTENT]: [requiredRule],
  };
};
